import { DEFAULT_TABLE_PAGE_SIZE } from 'src/constants/Pagination';

import { type FilterOptions } from './types';
import { type SiteConfigPageState, type SiteModalFieldLength } from './types';

export const SITE_MODAL_FIELD_LENGTH_VALUES: SiteModalFieldLength = {
  maxSiteCharLength: 255,
  maxDescriptionCharLength: 500,
};

export const INITIAL_FILTER_OPTIONS: FilterOptions = {
  sites: [],
  countries: [],
  orgs: [],
  subOrgs: [],
  regions: [],
  buildingTypes: [],
  isActive: [],
};

export const INITIAL_STATE: SiteConfigPageState = {
  isLoading: true,
  tableData: [],
  currentPage: 1,
  totalPages: 0,
  perPage: DEFAULT_TABLE_PAGE_SIZE,
  searchField: '',
  isCreateModalOpen: false,
  sites: [],
  countries: [],
  regions: [],
  orgs: [],
  subOrgs: [],
  buildingTypes: [],
  siteModalFieldLengths: SITE_MODAL_FIELD_LENGTH_VALUES,
  siteCoLocationMap: new Map<number, Set<string>>(),
  isAdvancedFilterSheetOpen: false,
  appliedFilterOptions: INITIAL_FILTER_OPTIONS,
  filterTags: [],
};
